query GetStateRegionsByCountryId($countryId: Int!) {
  country(id: $countryId) {
    stateRegions {
      nodes {
        id
        stateRegion
      }
    }
  }
}
